import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { toggleClass } from '../utils/dom'
import keycode from 'keycode'

const STATES = {
    SLIDER: 'is-slider',
    HIDDEN: 'is-hidden',
    ACTIVE: 'is-active',
}

export default class Gallery extends Component {
    constructor(element) {
        super(element, {
            propagate: false
        })

        this.ref = {
            items: [],
            thumbnails: [],
            arrowPrevious: null,
            arrowNext: null,
        }

        this.index = 0
    }

    prepare() {
        this.ref.thumbnails.forEach((thumb, index) => {
            thumb.addEventListener('click', event => {
                event.preventDefault()
                this.activate(index)
            })

            thumb.addEventListener('mouseover', event => {
                event.preventDefault()
                this.activate(index)
            })
        })

        this.ref.items.forEach(item => item.addEventListener('click', this.handleItemClick))

        if (this.ref.items.length > 1) {
            this.element.classList.add(STATES.SLIDER)

            if (this.ref.arrowPrevious && this.ref.arrowNext) {
                this.ref.arrowNext.addEventListener('click', event => {
                    event.preventDefault()
                    this.next()
                })

                this.ref.arrowPrevious.addEventListener('click', event => {
                    event.preventDefault()
                    this.previous()
                })
            }
        }

        EventBus.on('gallery:set', this.handleGallerySet)

        this.modal = Component.getFromElement(this.element.closest('[data-component="Modal"]'))
        if (this.modal) {
            this.modal.on({
                open: this.handleModalOpen,
                close: this.handleModalClose
            })
        }
    }

    destroy() {
        EventBus.off('gallery:set', this.handleGallerySet)
        document.removeEventListener('keydown', this.handleKeydown)
        if (this.modal) {
            this.modal.off({
                open: this.handleModalOpen,
                close: this.handleModalClose
            })
            this.modal = null
        }
    }

    handleGallerySet = ({index}) => {
        this.activate(index)
    }

    handleItemClick = event => {
        event.preventDefault()
        const index = this.ref.items.indexOf(event.currentTarget)

        this.createModal(index)
    }

    createModal(index) {
        if (this.options.propagate) {
            EventBus.emit('gallery:set', {
                index
            })
        }

        if (this.modal) {
            return
        }

        const modal = Component.getFromElement('gallery-modal')
        if (modal) {
            modal.open()
        }
    }

    handleModalOpen = () => {
        this.activate(this.index)
        document.addEventListener('keydown', this.handleKeydown)
    }

    handleModalClose = () => {
        document.removeEventListener('keydown', this.handleKeydown)
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'left') {
            this.previous()
        }

        if (keycode(event.keyCode) === 'right') {
            this.next()
        }
    }

    activate(index) {
        this.index = index

        this.ref.items.forEach((item, index) => toggleClass(item, STATES.ACTIVE, index === this.index))
        this.ref.thumbnails.forEach((element, index) => toggleClass(element, STATES.ACTIVE, index === this.index))

        if (this.ref.arrowPrevious) {
            toggleClass(this.ref.arrowPrevious, STATES.HIDDEN, this.index === 0)
        }

        if (this.ref.arrowNext) {
            toggleClass(this.ref.arrowNext, STATES.HIDDEN, this.index === this.ref.items.length - 1)
        }
    }

    previous() {
        const index = Math.max(this.index - 1, 0)
        this.activate(index)
    }

    next() {
        const index = Math.min(this.index + 1, this.ref.items.length - 1)
        this.activate(index)
    }
}